import { PaymentOption } from '@rx-applications/clientsite/shared/config/utils';
import { format, parseISO } from 'date-fns';

import { DAY_OF_MONTH_ZERO_FILL, YEAR_MONTH } from '@rx-applications/shared/utils';
import { FreeCancellationFilter } from '../constants';

export interface ReservationSearchDetails {
  hotelId: number;
  currencyCode: string;
  checkinDate: string;
  checkoutDate: string;
  rooms: string;
  references: string;
  paymentOption: PaymentOption;
  excludeMealPlanCode: number;
  freeCancellation: FreeCancellationFilter;
  websiteId: number;
  quoteId?: string;
  loyaltyGuaranteed?: boolean;
}

export interface ReservationDetailsRequest {
  HotelId: number;
  CurrencyCode: string;
  CheckInDay: string;
  CheckInMonthYear: string;
  CheckOutDay: string;
  CheckOutMonthYear: string;
  Room1Adults: number;
  Room2Adults: number;
  Room3Adults: number;
  Room4Adults: number;
  Room5Adults: number;
  Room6Adults: number;
  Room7Adults: number;
  Room8Adults: number;
  Room1Reference: string;
  Room2Reference: string;
  Room3Reference: string;
  Room4Reference: string;
  Room5Reference: string;
  Room6Reference: string;
  Room7Reference: string;
  Room8Reference: string;
  PaymentOption: PaymentOption;
  ExcludeMealPlanCode: number;
  FreeCancellation: FreeCancellationFilter;
  WebsiteId: number;
  QuoteId?: string;
  loyaltyGuaranteed?: boolean;
}

export class GetReservationDetailsRequest {
  constructor(public reservationDetails: ReservationSearchDetails) {}

  asRequest(): ReservationDetailsRequest {
    const [Room1Adults, Room2Adults, Room3Adults, Room4Adults, Room5Adults, Room6Adults, Room7Adults, Room8Adults] =
      this.reservationDetails.rooms.split(',');
    const [
      Room1Reference,
      Room2Reference = '',
      Room3Reference = '',
      Room4Reference = '',
      Room5Reference = '',
      Room6Reference = '',
      Room7Reference = '',
      Room8Reference = '',
    ] = this.reservationDetails.references.split(',');
    return {
      Room1Reference,
      Room2Reference,
      Room3Reference,
      Room4Reference,
      Room5Reference,
      Room6Reference,
      Room7Reference,
      Room8Reference,
      Room1Adults: +Room1Adults,
      Room2Adults: +Room2Adults,
      Room3Adults: +Room3Adults,
      Room4Adults: +Room4Adults,
      Room5Adults: +Room5Adults,
      Room6Adults: +Room6Adults,
      Room7Adults: +Room7Adults,
      Room8Adults: +Room8Adults,
      HotelId: this.reservationDetails.hotelId,
      CurrencyCode: this.reservationDetails.currencyCode,
      CheckInDay: this.dayOfDate(this.reservationDetails.checkinDate),
      CheckInMonthYear: this.yearMonthOfDate(this.reservationDetails.checkinDate),
      CheckOutDay: this.dayOfDate(this.reservationDetails.checkoutDate),
      CheckOutMonthYear: this.yearMonthOfDate(this.reservationDetails.checkoutDate),
      PaymentOption: this.reservationDetails.paymentOption,
      ExcludeMealPlanCode: this.reservationDetails.excludeMealPlanCode,
      FreeCancellation: this.reservationDetails.freeCancellation || FreeCancellationFilter.All,
      WebsiteId: this.reservationDetails.websiteId,
      ...(this.reservationDetails.loyaltyGuaranteed !== undefined && this.reservationDetails.loyaltyGuaranteed !== null
        ? { loyaltyGuaranteed: this.reservationDetails.loyaltyGuaranteed }
        : {}),
    };
  }

  asRequestWithQuoteId(): ReservationDetailsRequest {
    const reservationDetailsRequest = this.asRequest();
    if (this.reservationDetails.quoteId) {
      reservationDetailsRequest.QuoteId = this.reservationDetails.quoteId;
    }

    return reservationDetailsRequest;
  }

  private dayOfDate(date: string) {
    return format(parseISO(date), DAY_OF_MONTH_ZERO_FILL);
  }

  private yearMonthOfDate(date: string) {
    return format(parseISO(date), YEAR_MONTH);
  }
}
